import PinChangeDialog from './PinChangeDialog';

export default PinChangeDialog;